import { consumerBookingStatusPresentation } from '@/lib/booking-status';
import { cn } from '@/lib/utils';

/**
 * Shared consumer booking-status pill.
 *
 * Renders label + color from `consumerBookingStatusPresentation` (the customer
 * mobile app mapping) so all consumer surfaces — dashboard, list, history,
 * detail — show identical badges.
 *
 * Colors are dynamic hex from the mobile spec and have no matching Tailwind
 * token, so they ride inline `style`.
 */
export function BookingStatusBadge({
  status,
  className,
}: {
  status: string;
  className?: string;
}) {
  const { label, backgroundColor, textColor } =
    consumerBookingStatusPresentation(status);
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-semibold',
        className
      )}
      style={{ backgroundColor, color: textColor }}
    >
      {label}
    </span>
  );
}
